import { useCallback, useEffect, useState } from 'react'

import QuickReferenceIcon from '@/assets/icons/icon-quick-reference-all.svg'
import { Tooltip } from '@/components/ui/tooltip.tsx'

import { InfoQuickViewContent } from './InfoQuickViewContent.tsx'
import { InfoQuickViewData, Props } from './types'

export { type InfoQuickViewData } from './types'

export const InfoQuickView = ({ data: initialData, fetchData }: Props) => {
  const [needLoad, setNeedLoad] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<InfoQuickViewData>(initialData || [])

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      const result = await fetchData!()

      setData(result)
      setLoading(false)
    }

    if (needLoad && fetchData) {
      load()
    }
  }, [fetchData, needLoad])

  const handleRefresh = useCallback(() => {
    if (loading) {
      return
    }

    setNeedLoad(true)
  }, [loading])

  const handleMouseLeave = useCallback(() => {
    if (fetchData) {
      setData([])
    }
    setNeedLoad(false)
  }, [setNeedLoad, fetchData])

  return (
    <div
      onMouseEnter={handleRefresh}
      onMouseLeave={handleMouseLeave}
    >
      <Tooltip
        side="left"
        className="cursor-pointer"
        content={
          <InfoQuickViewContent
            data={data}
            isLoading={loading}
          />
        }
      >
        <QuickReferenceIcon />
      </Tooltip>
    </div>
  )
}
